(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["copy-email"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__copyEmailReady) return;
  window.__copyEmailReady = true;
  function fallbackCopy(text) {
    var t = document.createElement('textarea');
    t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
    document.body.appendChild(t); t.select();
    var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(t);
    return ok;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-copy-email]');
    if (!btn) return;
    e.preventDefault();
    var text = btn.getAttribute('data-copy-email');
    var label = btn.querySelector('[data-copy-label]');
    function done(ok) {
      if (!label) return;
      label.textContent = ok ? 'Copied' : text;
      btn.classList.toggle('is-copied', ok);
      clearTimeout(btn.__t);
      btn.__t = setTimeout(function () { label.textContent = 'Copy'; btn.classList.remove('is-copied'); }, 2200);
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(fallbackCopy(text)); });
    } else {
      done(fallbackCopy(text));
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
